import { Modal, Button } from 'react-bootstrap'
import { LogOut } from 'lucide-react'
import styles from '../../../pages/Layout/dashboard.module.css'

function ModalLogout(props) {
  const { show, onHide, onConfirm } = props

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      contentClassName={styles.modalContent}
      backdrop="static"
    >
      <div className={`${styles.modalBody} text-center`}>
        <div
          className="rounded bg-danger bg-opacity-10 d-flex align-items-center justify-content-center mx-auto mb-4"
          style={{ width: '80px', height: '80px' }}
        >
          <LogOut size={40} className="text-danger" />
        </div>

        <h4 className={styles.modalTitle}>Sign Out?</h4>
        <p className="text-muted mt-2 mb-4">
          Are you sure you want to end your session?
        </p>

        <div className="d-flex justify-content-center gap-3">
          <Button
            variant="link"
            onClick={onHide}
            className="text-decoration-none text-muted fw-bold"
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={onConfirm}
            className={styles.btnDanger}
          >
            Sign Out
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default ModalLogout
